import {Zero, Logger, Components, Utils} from 'Zero';

const Log = new Logger("Zero/StoreLocator/ZResultsCounter");

export default class ZResultsCounter extends Components {

  get Messages() {
    return {
      "StoreLocator:GeoJson:Loaded": this.updateResultsCounter
    };
  }

  constructor(element) {
    super(element);
  }

  updateResultsCounter(msg) {
    const inCart = document.body.classList.contains('t-cart');
    if (msg.geojson && msg.geojson.features) {
      var resultsNumber = 0;
      for (var i = 0, store; (store = msg.geojson.features[i++]);) {
        if (inCart) {
          if (store.properties.features.hasOwnProperty('CLICK_AND_COLLECT')) {
            resultsNumber++;
          }
        } else {
          if (!store.properties.storeHidden) {
            resultsNumber++;
          }
        }
      }
      this.element.text(resultsNumber);
    } else {
      this.element.text('0');
    }
  }
}

export {
  ZResultsCounter
}
